module.exports = __webpack_public_path__ + "static/img/wx-pay-img.fec2d89.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ts-img/wx-pay-img.png
// module id = cY1U
// module chunks = 1